export enum TransferStoreWorkshopStateEnums {
  open = 1,
  close = 2,
  annulled = 3,
  printed = 4,
}

export enum TransferStoreWorkshopTypeEnums {
  cleaning = 2,
  repair = 3,
}